module.exports = __webpack_public_path__ + "img/loading.18fa958c.gif";